export enum SuggestedSearchListItemType {
	Event,
	Tournament,
}
